module.exports = __webpack_public_path__ + "img/logo.b106abf1.svg";